import React from 'react';
import githubimg from '../GithubImg/github.png'
import './Design.css'
import { useState, useContext } from 'react'
import GithubContext from '../../context/github/GithubContext';
import AlertContext from '../../context/alert/AlertContext';
import { searchUsers } from '../../context/github/GithubActions'
import { type } from '@testing-library/user-event/dist/type';

function UserSearch() {

  
  const [text,setText] = useState('');

  const {users, dispatch} = useContext(GithubContext);

  const { setAlert} = useContext(AlertContext)

  const handleChange = (e)=>{
 
   setText(e.target.value)


  }

  const handleSubmit = async(e) =>{


    e.preventDefault()

     if(text === ''){

      //This is the AlertContext set up

       setAlert("Please Enter Something", 'error')

     }else{

       //Implement search functionality

         const users = await searchUsers(text);
          dispatch({type: 'SET_LOADING'})
          dispatch({type: 'GET_USERS', payload: users})
          setText('');

     }


  }
 
   




  return <div className=' ml-3 lg:flex items-center justify-around mt-3'>

 <div className='grid grid-cols-1 xl:grid-cols-2
  
  lg:grid-cols-2 md:grid-cols-2 mb-7 gap-8'>

      <div>
       
        <form onSubmit={handleSubmit}>

           <div className="form-control mt-5">

               <div className="relative">
 
               <input type='text' 

               className='w-full h-14 pr-40 bg-white input input-lg

               text-black border-2 border-slate-300 focus' 

               placeholder='Search' value={text} onChange={handleChange}/>

 
                 <button type='submit' className='absolute h-12 top-1 right-0 
                 
                  w-24  btn btn-sm background rounded-md shadow-sm hover:shadow-md  shadow-black hover:shadow-slate-500'>Go</button>

               </div>

           </div>

        </form>
 
      </div>

     {  
        users.length > 0 && ( <div> 

          <button onClick={() => dispatch({type:'CLEAR_USERS'})}  className='btn back mt-1 h-10 ml-1 xl:mt-6  xl:w-24 text-sm ease-out duration-300 hover:bg-purple-500
           hover:scale-x-105 hover:scale-y-105 focus:outline-none border-purple-800'>CLear</button>
       
          </div> )
       
       }


  
    </div>


    <div className='shadow-sm shadow-white border-8 lg:mb-5 relative  w-11/12 lg:w-80'>

    <img className='shadow-xl w-auto  lg:ml-0 shadow-black  lg:w-80  rounded-xl border-white border-4
    
    ease-out duration-300 hover:scale-x-95 hover:scale-y-95' src={githubimg} alt='Github' />


      </div>



  </div>
  
  
 
}

export default UserSearch;
